module.exports = __webpack_public_path__ + "static/img/hm_section_detect_bg.4685463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/healthMonitoring/hm_section_detect_bg.png
// module id = D8L1
// module chunks = 1